import * as angular from "angular";

angular
.module('bringoz.admin.oms')
.component('omsAutomaticQuotesTable', {
  bindings: {
    quotes: '<',
    onEdit: '&',
    onDelete: '&',
  },
  template: require('./oms-automatic-quotes-table.html').default
});
